<div
  [ngClass]="fieldClassesString"
  [attr.id]="id"
>
  <label
    [attr.for]="id"
    soho-label
      [required]="isRequired"
    lm-label
      [layoutField] = "field"
      [layoutInfo]="layoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [personalize]="personalize"
    lm-text-style
      [textStyle]="field?.label?.textStyle"
  >{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  </label>
  <ng-container *ngIf="displayAsText; else ShowRadioButtons">
    <div
      lm-field-options
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      (contextmenu)="onContextMenu($event)"
      class="lm-radio-field-options"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)"
    >
      <p class="lm-text-data hide-white-space"
          attr.id="{{id}}"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          [style.padding]="'0px'"
          [ngStyle]="{'display': 'inline-block'}"
          soho-alert
      >{{modelField.value | stateAsText:modelField.states}}</p>
    </div>
  </ng-container>
  <ng-template #ShowRadioButtons >
    <div
      [ngClass]="{'lm-is-radio-in-paragraph': lmParagraphLayoutInfo, 'lm-radio-field-options': true}"
      lm-field-options
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)">
      <div class="radio-button-group-wrapper"
           attr.aria-labelledby="{{id}}"
           role="radiogroup"
           [attr.tabindex]="isInAccessibilityMode && isReadOnly ? 0 : null">
        <ng-template ngFor let-item [ngForOf]="values" [ngForTrackBy]="trackByValue" let-indx="index">
          <!-- the name="{{id}}_Option" is needed for the radio buttons to be correctly interpreted as separate fields.
               removing it caused https://jira.lawson.com/browse/LMCLIENT-32155 -->
          <ng-container *ngIf="(item && item.label != ' ') && !displayAsText">
            <input
              type="radio"
              class="radio"
              attr.id="{{id}}_{{indx}}_Option"
              name="{{id}}_Option"
              attr.name="{{id}}_Option"
              [attr.bindId]="bindId"
              [attr.disabled]="isReadOnly ? true : null"
              value="{{item?.value}}"
              [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
              (ngModelChange)="onNgModelChange($event)"
              soho-radiobutton
              soho-alert
              soho-trackdirty
                (dirty)="onDirty($event)"
                (pristine)="onPristine($event)"
                (afterResetDirty)="onAfterResetDirty($event)"
              soho-input-validate
                (error)="onError($event)"
                (valid)="onValid($event)"/>
            <label
              soho-label
                [forRadioButton]="true"
              attr.for="{{id}}_{{indx}}_Option"
              class="lm-radio-button-label"
            >
              {{item?.label}}
            </label>
            <br *ngIf="!isHorizontal && indx != (values.length - 1)"/>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
